<template>
  <div>
    <Table
      resource="Settings"
      :actions="actions"
      :items="$store.getters['settings/tableData']"
      :detail="$store.getters['settings/detailData']"
      :fields="$store.getters['settings/tableFields']"
      :pagination="$store.state.settings.tablePagination"
      :keyword="$store.state.settings.tableKeyword"
      :loading="$store.state.settings.loadingTable"
      :filter="$store.state.settings.tableFilter"
      :sort="$store.state.settings.tableSort"
      :sort-options="sortOptions"
      @changeFields="changeFields"
      @resetFields="resetFields"
      @filter="filterData"
      @sort="sortData"
      @load="loadData"
      @delete="deleteData"
      @loadDetail="loadDetail"
      @resetDetail="resetDetail"
      @paginate="paginate"
      @search="search"
    />
  </div>
</template>

<script>
import Table from '@/layouts/components/Table.vue'

export default {
  components: {
    Table,
  },
  data() {
    return {
      // Sort
      sortOptions: [
        {
          key: 'created_at', direction: 'desc', label: 'Terbaru', default: true,
        },
        { key: 'created_at', direction: 'asc', label: 'Terlama' },
      ],

      actions: [
        'create',
        'view',
        'update',
        'delete',
      ],
    }
  },
  methods: {
    loadData() {
      return this.$store.dispatch('settings/getTableData')
    },
    loadDetail(id) {
      return this.$store.dispatch('settings/getDetail', id)
    },
    deleteData(id, callback) {
      return this.$store.dispatch('settings/delete', id)
        .then(callback)
    },
    resetDetail() {
      this.$store.commit('settings/SET_DETAIL_DATA', undefined)
    },
    changeFields(val) {
      this.$store.commit('settings/SET_TABLE_FIELDS', val)
    },
    resetFields() {
      this.$store.commit('settings/RESET_TABLE_FIELDS')
    },
    filterData(val) {
      this.$store.commit('settings/SET_TABLE_FILTER', val)
    },
    sortData(val) {
      this.$store.commit('settings/SET_TABLE_SORT', val)
    },
    paginate(val) {
      this.$store.commit('settings/SET_TABLE_PAGINATION', val)
    },
    search(val) {
      this.$store.commit('settings/SET_TABLE_KEYWORD', val)
    },
  },
}
</script>
